import APIService from 'services/APIService'

const api = APIService()

export const listWebhookSubscriptions = (bpId) =>
  api.get(`/building-passport/${bpId}/webhooks`)

export const createWebhookSubscription = (bpId, payload) =>
  api.post(`/building-passport/${bpId}/webhooks`, payload)

export const deleteWebhookSubscription = (bpId, subscriptionId) =>
  api.delete(`/building-passport/${bpId}/webhooks/${subscriptionId}`)
